import { createContext, useContext } from 'react';

import type { ExitIntentReason } from '$src/hooks/client/useExitIntent';

interface ExitIntentContextValue {
  isOpen: boolean;
  triggerExitIntent: () => boolean;
  onLeave: () => void;
  onReasonSelected: (reason: ExitIntentReason) => Promise<void>;
  setPendingExitCallback: (callback: (() => void) | null) => void;
}

export const ExitIntentContext = createContext<ExitIntentContextValue | null>(null);

export function useExitIntentContext(): ExitIntentContextValue {
  const context = useContext(ExitIntentContext);
  if (!context) {
    throw new Error('useExitIntentContext must be used within an ExitIntentProvider');
  }
  return context;
}

